//style
import './footer.css';

function Footer(){
    return(
        <div className="footer">
            <a href="https://survey.confirmit.com/isa/DYOIIYHQMFFRFADFGXOAPVARPMKAPMEA/Canada_NPS/Best%20Buy%20Sweepstakes_English.pdf" target="_blank" rel="noreferrer">Official Sweepstakes Rules</a>
            <span className="separator">|</span>
            <a href="https://survey.confirmit.com/isa/DYOIIYHQMFFRFADFGXOAPVARPMKAPMEA/Canada_NPS/Best%20Buy%20Sweepstakes_French.pdf" target="_blank" rel="noreferrer">Règlements officiel du concours</a>
            <br/>
            <a href="http://www.bestbuy.ca/en-CA/help/privacy-policy/hc1139.aspx" target="_blank" rel="noreferrer">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="https://www.bestbuy.ca/fr-ca/aide/blt372c78db41358a01/blt12691f41ac6895d7" target="_blank" rel="noreferrer">Politique de confidentialité</a>
        </div>
    )
}

export default Footer;